export default "__VITE_ASSET__c3SUMbrh__"